export interface SearchableItem {
	id: string
	searchLabel: string
	[key: string]: unknown
}

export function filterAndScoreItems<T extends SearchableItem>(
	items: T[],
	query: string,
	searchFields: (keyof T)[] = ["searchLabel"],
	maxResults?: number
): T[] {
	if (!query.trim()) return items

	const searchQuery = query.toLowerCase().trim()

	const results = items
		.map((item) => {
			let maxScore = 0

			for (const field of searchFields) {
				const fieldValue = String(item[field]).toLowerCase()
				let score = 0

				if (fieldValue === searchQuery) {
					score = 1000
				} else if (fieldValue.startsWith(searchQuery)) {
					score = 100
				} else if (fieldValue.includes(searchQuery)) {
					score = 10
				} else {
					score = 0
				}

				maxScore = Math.max(maxScore, score)
			}

			return { item, score: maxScore }
		})
		.filter((result) => result.score > 0)
		.sort((a, b) => b.score - a.score)
		.map((result) => result.item)

	return maxResults ? results.slice(0, maxResults) : results
}
